export const CREATE_WORKSPACE_FORM_HEADER = "Create Workspace";
export const CREATE_WORKSPACE_FORM_DESCRIPTION = "Add a new workspace.";
export const CREATE_WORKSPACE_FORM_BUTTON = "Create Workspace";
